import { render, staticRenderFns } from "./FiltroCategoriaEstabelecimento.vue?vue&type=template&id=3f4cb1ba&"
import script from "./FiltroCategoriaEstabelecimento.vue?vue&type=script&lang=js&"
export * from "./FiltroCategoriaEstabelecimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports